import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Modal, Form, Nav, Tab } from 'react-bootstrap';
import Header from '../component/Header';
import ExploreResultLocations from '../component/ExploreResultLocations';
import Footer from '../component/Footer';
import ProfileUserImg from '../assets/images/profile-user-img.svg';
import ProfileComp from '../component/ProfileComp';
import ProfileNotificationsComp from '../component/ProfileNotificationsComp';
import ProfileDocumentsComp from '../component/ProfileDocumentsComp';
import { GET_CLIENT_PROFILE, GET_AGENT_PROFILE } from '../api/constants';

function Profile() {
    const user = JSON.parse(localStorage.getItem("user"))
    const URL = user.role === "agent" ? GET_AGENT_PROFILE : GET_CLIENT_PROFILE;
    const [profile, setProfile] = React.useState({});

    const getProfile = async () => {
        //Get token
        const token = localStorage.getItem("token");
        try {
            const url = URL;
            const res = await fetch(url, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            const data = await res.json();
            console.log(data);
            console.log(data?.data);

            if (data?.status) {
                setProfile(data.data);
            } else {
                setProfile({});
            }

        } catch (err) {
            console.error("error", err);
            setProfile({});
        }
    };

    useEffect(() => {
        getProfile();
    }, []);

    useEffect(() => {
    }, [profile]);

    // Calculate upcoming tours count
    const upcomingToursCount = profile?.upcoming_tours?.length || 0;


    return (
        <div className="main profile-page">
            <Header />
            <section className="profile-section common-padding">
                <Container>
                    <Tab.Container id="left-tabs-example" defaultActiveKey="profile">
                        <Row>
                            <Col md={3}>
                                <Nav variant="pills" className="flex-column">
                                    <Nav.Item>
                                        <Nav.Link eventKey="profile">Profile</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="notifications" className="d-flex align-items-center">
                                            Notifications
                                            {upcomingToursCount > 0 && (
                                                <span className="badge bg-danger rounded-circle ms-2" style={{fontSize: '0.75rem', width: '20px', height: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                                    {upcomingToursCount}
                                                </span>
                                            )}
                                        </Nav.Link>
                                    </Nav.Item>
                                    {user.role == "agent" && (
                                    <Nav.Item>
                                        <Nav.Link eventKey="documents">Documents</Nav.Link>
                                    </Nav.Item>)}
                                    
                                </Nav>
                            </Col>
                            <Col md={9}>
                                <Tab.Content>
                                    <Tab.Pane eventKey="profile">
                                        <ProfileComp profile={profile} />
                                    </Tab.Pane>

                                    <Tab.Pane eventKey="notifications">
                                        <ProfileNotificationsComp profile={profile} />
                                    </Tab.Pane>
                                
                                    <Tab.Pane eventKey="documents">
                                        <ProfileDocumentsComp profile={profile} />
                                    </Tab.Pane>
                                </Tab.Content>
                            </Col>
                        </Row>
                    </Tab.Container>
                </Container>
            </section>
            <ExploreResultLocations />
            <Footer />
        </div>
    );
}
export default Profile;